import * as React from 'react';
import { useEffect } from 'react';
import { useForm } from 'react-final-form';

import { FormValues } from '../../../types';

interface Props {
	enabled?: boolean;
}

const FormValidationTrigger: React.FC<Props> = ({ enabled }) => {
	const form = useForm<FormValues>();

	useEffect(() => {
		let hasTriggered = false;

		const unsubscribe = form.subscribe(
			({ errors }) => {
				if (!enabled || hasTriggered || !errors || !Object.keys(errors).length) {
					return;
				}

				hasTriggered = true;

				form.submit();
			},
			{ errors: true }
		);

		return unsubscribe;
	}, [enabled, form]);

	return null;
};

export default FormValidationTrigger;
